import React, {  useEffect, useState } from "react";
import {  Modal, ModalBody, ModalHeader } from "reactstrap";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import {
    CircularAvatar,
    ErrorSuccessModal,
    TableLoader,
} from "../../commons";
import { CalenderIcon } from "../../Icon";
import { Toaster, toast } from "react-hot-toast";
import { getAllFinacUsersAction, resetSession } from "../../../redux/auth";
import Select, { components } from "react-select";
import useDebounce from "../../../customHooks/useDebounce";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import { resetError, resetMessage, resetSharedJobSuccess, resetStatusCode, shareJobsWithTeamMembersAction } from "../../../redux/jobs";
import { ShareJobsWithTeamMembersPayloadType } from "../../../commonTypes/listing";
import "./shareJobs.scss"
import { LoginResponseType } from "../../../redux/auth/authTypes";
export type SortType={
    name: string;
    value: string; 
   }
type AppProps = {
    modal: boolean;
    token: string | null;
    toggleModal: () => void;
    jobTypeId?: string;
    fetching: boolean;
    statusCode: number | null;
    success: number | null;
    error: string | null | undefined;
    message: string | null;
    finacUser: any;
    singleJobsData: any;
    loginData: LoginResponseType;
    showUsersWorkingOnJobData: any;
    searchData?:string;
    sortByTargetEndDate?:SortType
    sortByJobType?:SortType
    sortByStatus?:SortType
    sortByClientCode?:SortType
    sortByClientName?:SortType
    dispatchResetSession: () => void;
    dispatchResetError: () => void;
    dispatchResetSuccess: () => void;
    dispatchResetMessage: () => void;
    dispatchResetStatusCode: () => void;
    dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
    dispatchShareJobsWithTeamMembersAction: (data: ShareJobsWithTeamMembersPayloadType) => void;
    dispatchGetAllOpenJobsListAction: (data: any) => void;
    setOpenStatus: React.Dispatch<React.SetStateAction<string>>;
    setJobProgressSearchData: React.Dispatch<React.SetStateAction<string>>;
    setClearFilter: React.Dispatch<React.SetStateAction<boolean>>;
    openStatus?:string
    listOffset?:number
    listSetOffset?:any
    jobPriority?:any

};
const ShowShareJobModal = ({
    modal,
    toggleModal,
    token,
    jobTypeId,
    statusCode,
    success,
    error,
    message,
    fetching,
    finacUser,
    singleJobsData,
    loginData,
    setOpenStatus,
    setClearFilter,
    searchData,
    openStatus,
    setJobProgressSearchData,
    showUsersWorkingOnJobData,
    sortByTargetEndDate,
    sortByJobType,
    sortByStatus,
    sortByClientCode,
    sortByClientName,
    dispatchResetSession,
    dispatchResetMessage,
    dispatchResetError,
    dispatchResetSuccess,
    dispatchResetStatusCode,
    dispatchGetAllFinacUsersAction,
    dispatchShareJobsWithTeamMembersAction,
    dispatchGetAllOpenJobsListAction,
    listOffset,
    listSetOffset,
    jobPriority
}: AppProps) => {
    const [limit, setLimit] = useState(50);
    const [offset, setOffset] = useState<number>(0);
    const [text, setText] = useState("");
    const [finalUserList, setFinalUserList] = useState<any>([]);
    const [finalUserListData, setFinalUserListData] = useState<any>([]);
    const [selectedDropdownList, setSelectedDropdownList] = useState<any>([]);
    const [selectedDropdownListId, setSelectedDropdownListIds] = useState<number[]>([]);
    useEffect(() => {
        dispatchResetMessage()
        dispatchResetError()
        dispatchResetSuccess()
        dispatchResetStatusCode()
    }, [])

    useEffect(() => {
        if (singleJobsData) {
            const finalUserData = singleJobsData?.access_members?.map((user: any) => {
                return {
                    value: user?.user_id,
                    label: `${user?.first_name} ${user?.last_name}`,
                    image: user?.profile_pic?.file_url,
                };
            });
            if (finalUserData?.length) {
                setSelectedDropdownList([...finalUserData])
            }
            else {
                setSelectedDropdownList([])
            }
        } else {
            setSelectedDropdownList([])
        }
    }, [singleJobsData])

    useEffect(() => {
        const data = finacUser?.data?.filter((e: any) => e?.user_id !== loginData?.user_id)
        const finalUserData = data?.map((user: any) => {
            return {
                value: user?.user_id,
                label: `${user?.first_name} ${user?.last_name}`,
                image: user?.profile_pic?.file_url,
            };
        });
        if (offset > 0 && finalUserList?.length) {
            setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
            setFinalUserList(finalUserData);
        }
    }, [finacUser]);
    //Lead dropdown
    useEffect(() => {
        if (token) {
            let finalUserData = {
                token,
                offset: offset,
                limit: limit,
                user_type: 'stco_users',
                status: 1,
                search_term: text,
            };
            if (offset <= finacUser?.total_count) {
                dispatchGetAllFinacUsersAction(finalUserData)
            }
        }
    }, [offset])

    useEffect(() => {
        let jobShareTeamMembersId = selectedDropdownList?.map((item: any) => item.value)
        if (jobShareTeamMembersId?.length) {
            setSelectedDropdownListIds([...jobShareTeamMembersId])
        }
        if (finalUserList?.length) {
            if (selectedDropdownList?.length) {
                let filterData = finalUserList?.filter((el: any) => {
                    return !jobShareTeamMembersId?.includes(el?.value)
                })
                setFinalUserListData([...filterData])
            }
            else {
                setFinalUserListData([...finalUserList])
            }
        }
    }, [finalUserList, selectedDropdownList])

    const fetchNewLeadData = (search: string) => {
        const finalData = {
            token,
            offset,
            limit,
            user_type: 'stco_users',
            status: 1,
            search_term: text,
        }
        dispatchGetAllFinacUsersAction(finalData)
    }

    useDebounce(() => {
        if (text) {
            fetchNewLeadData(text)
        }
        else {
            const finalData = {
                token,
                offset,
                limit,
                user_type: 'stco_users',
                status: 1,
                search_term: text,
            }
            dispatchGetAllFinacUsersAction(finalData)
        }
    }, 500, [text]);

    const openJobStatusStyle = () => {
        return {
            padding: "4px 14px",
            color: "#82b01f",
            background: "#e7f0d4",
            borderRadius: "16px",
            fontSize: "12px",
            fontWeight: "400",
        };
    };
    const closeJobStatusStyle = () => {
        return {
            padding: "4px 14px",
            color: "#6f7a90",
            background: "#f4f6f8",
            borderRadius: "16px",
            fontSize: "12px",
            fontWeight: "400",
        };
    };

    const Option = (props: any) => {
        const { data } = props;
        return (
            <components.Option {...props} >
                <div className='d-flex justify-content-sm-start' style={{ gap: '10px' }}>
                    <CircularAvatar name={data?.label} image={data?.image && data?.image} />
                    {data?.label}
                </div>
            </components.Option>
        );

    };

    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                );
            } else if (!!error && statusCode !== 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetError();
                        }}
                    />
                );
            }
        }
        if (success === 1) {
            toast.success("Share jobs settings updated successfully!")
            toggleModal();
            dispatchResetSuccess();
            let finalData = {
                token,
                limit,
                offset: 0,
                search_term: searchData,
                filterStatus: openStatus,
                endDate: sortByTargetEndDate?.value,
                jobType: sortByJobType?.value,
                status: sortByStatus?.value,
                sortByClientCode:sortByClientCode?.value,
                clientName:sortByClientName?.value,
                jobPriority:jobPriority?.value

            };
            if(listOffset==0){

                dispatchGetAllOpenJobsListAction(finalData);
            }
            else {
                listSetOffset(0)
            }
        }

        return false;
    };

    const checkBottom = () => {
        setOffset((prv: number) => prv + limit);
    };

    const handleAccessTeamMembersDetailsChange = (data: any) => {
        const filterOptionList = finalUserList?.length > 0 && finalUserList?.filter((el: any) => el.value !== data.value)
        setFinalUserList([...filterOptionList])
        if (selectedDropdownList?.length) {
            setSelectedDropdownList((prev: any) => [...prev, {
                image: data?.image,
                label: data?.label,
                value: data?.value
            }])
        } else {
            setSelectedDropdownList([{
                image: data?.image,
                label: data?.label,
                value: data?.value
            }])
        }
    }

    const removeSelectedData = (id: number) => {
        const filterData = selectedDropdownList?.filter((el: any) => el.value !== id)
        if (filterData?.length) {
            setSelectedDropdownList([...filterData])
        }
        else {
            setSelectedDropdownList([])
            setSelectedDropdownListIds([])
        }
    }

    const handleSaveShareJobs = () => {
        if (token) {
            let finalData = {
                token,
                id: showUsersWorkingOnJobData?._id,
                jobId: showUsersWorkingOnJobData?.job_id,
                accessMemberIds: selectedDropdownListId
            }
            dispatchShareJobsWithTeamMembersAction(finalData)
            listSetOffset(0)
        }
    }

    return (
        <div>
            <Modal
                centered
                isOpen={modal}
                toggle={toggleModal}
                size="xl"
                backdrop="static"
            // keyboard={false}
            >
                <ModalHeader className="pt-3 pl-3 pr-3" id="cross-cut" toggle={toggleModal}>
                    Share Jobs with Users
                </ModalHeader>
                <ModalBody className="p-2" style={{ paddingLeft: "40px" }}>
                    <>
                        <div
                            className="pl-1"
                        // style={{ height: "400px", overflowY: "scroll" }}
                        >
                            {fetching && offset === 0 ? (
                                <TableLoader Rows={10} ColumnPerRow={7} />
                            ) : (
                                <>
                                    <div className="d-flex col-md-12" >
                                        <div className="col-md-6 mt-3">
                                            <p style={{ color: "#262a44", fontSize: "13px" }}>SEARCH OR SELECT USER FROM LIST TO SHARE JOBS WITH</p>
                                            <div className='col-md-12 ml-0 pl-0 mt-0'>
                                                {/* <Label className='mb-1' style={{ fontSize: "14px" }}>Lead Assign To</Label> */}
                                                <Select
                                                    // styles={dropDownStyle}
                                                    // isMulti
                                                    options={finalUserListData}
                                                    value={[{ label: "Select or Search User", value: null }]}
                                                    components={{ Option }}
                                                    onChange={(e) => handleAccessTeamMembersDetailsChange(e)}
                                                    isSearchable={true}
                                                    placeholder="Select or Search User"
                                                    isLoading={fetching}
                                                    onMenuClose={() => setOffset(0)}
                                                    onMenuScrollToBottom={checkBottom}
                                                    onInputChange={(e) => {
                                                        setText(e)
                                                    }}
                                                />

                                            </div>
                                            <div className="col-md-12" style={{ height: "45vh" }}>
                                                {/* selectedDropdownList?.lemgth>5?'scroll':"none" */}
                                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2%", maxHeight: "39vh", overflow: "auto", paddingBottom: "20px" }}>
                                                    {
                                                        !!selectedDropdownList?.length && selectedDropdownList?.map((data: any) => {
                                                            return <div className="d-flex justify-content-between mt-2 p-1 w-100" style={{ gap: "10px", border: "1px solid #bfcbe1", borderRadius: "6px", alignItems: 'center' }}>
                                                                <div className="d-flex">
                                                                    <CircularAvatar name={data?.label} image={data?.image && data?.image} />
                                                                    <span className="ml-1">{data?.label}</span></div>
                                                                <span id="cross-cut" className="pointer" style={{ right: "-4px" }}
                                                                    onClick={() => removeSelectedData(data.value)}
                                                                >X</span>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-12 text-left'>
                                                    <button className='btn btn-primary mr-2'
                                                        onClick={handleSaveShareJobs}
                                                    // disabled={!selectedDropdownList?.length}
                                                    >
                                                        Save Changes
                                                    </button>
                                                    <button
                                                        className='btn'
                                                        style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
                                                        onClick={toggleModal}>
                                                        Cancel
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                        {/* </ContentArea> */}
                                        <div className="col-md-6 mb-3 p-0" style={{ height: "80%" }}>
                                            <div
                                                className="mt-2 p-0"
                                                style={{ cursor: "pointer", border: "1px solid #bfcbe1", borderRadius: "8px" }}
                                            >
                                                <div className="list-header pl-3 pt-3">
                                                    Jobs Summary
                                                </div>
                                                <hr style={{ borderColor: "#bfcbe1" }} />
                                                <div className="inside-card-header d-flex w-100 pt-1 pl-3">
                                                    <span
                                                        style={{
                                                            color: "#6e7491",
                                                            fontSize: "13px",
                                                            fontWeight: "500",
                                                            width: "40%",
                                                        }}
                                                    >
                                                        Job Type & ID
                                                    </span>
                                                    <span
                                                        style={{
                                                            width: "60%",
                                                            fontSize: "14px",
                                                            color: "#262a44",
                                                            fontWeight: "400",
                                                            paddingRight: '5px',
                                                            wordWrap: "break-word"
                                                        }}
                                                    >{`${showUsersWorkingOnJobData?.job_id}_${showUsersWorkingOnJobData?.job_type}`}</span>
                                                </div>
                                                <div className="inside-card-header d-flex w-100 pt-3 pl-3">
                                                    <span
                                                        style={{
                                                            color: "#6e7491",
                                                            fontSize: "13px",
                                                            fontWeight: "500",
                                                            width: "40%",
                                                        }}
                                                    >
                                                        Client Details
                                                    </span>
                                                    <span
                                                        style={{
                                                            width: "60%",
                                                            fontSize: "14px",
                                                            color: "#262a44",
                                                            fontWeight: "400",
                                                            paddingRight: '5px',
                                                            wordWrap: "break-word"
                                                        }}
                                                    >{`${showUsersWorkingOnJobData?.client_details?.company_name}(${showUsersWorkingOnJobData?.client_details?.client_code})`}</span>
                                                </div>
                                                <div className="inside-card-header d-flex w-100 pt-3 pl-3">
                                                    <span
                                                        style={{
                                                            color: "#6e7491",
                                                            fontSize: "13px",
                                                            fontWeight: "500",
                                                            width: "40%",
                                                        }}
                                                    >
                                                        Target End Date
                                                    </span>
                                                    {showUsersWorkingOnJobData?.target_end_date ?
                                                        <div style={{ width: "60%", alignItems: "center" }}>
                                                            <span
                                                                className="calender-icon"
                                                                style={{
                                                                    right: "12px",
                                                                    top: "35px",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                {" "}
                                                                <CalenderIcon />
                                                            </span>
                                                            <span
                                                                style={{
                                                                    width: "60%",
                                                                    fontSize: "14px",
                                                                    paddingLeft: "3px",
                                                                    color: "#262a44",
                                                                    fontWeight: "400",
                                                                }}
                                                            >
                                                                {" "}
                                                                {showUsersWorkingOnJobData?.target_end_date}
                                                            </span>
                                                        </div> : <span style={{
                                                            width: "60%",
                                                            fontSize: "14px",
                                                            color: "#262a44",
                                                            fontWeight: "400",
                                                        }}>--/--</span>}
                                                </div>
                                                <div className="inside-card-header d-flex w-100 pt-3 pl-3">
                                                    <span
                                                        style={{
                                                            color: "#6e7491",
                                                            fontSize: "13px",
                                                            fontWeight: "500",
                                                            width: "40%",
                                                        }}
                                                    >
                                                        Status
                                                    </span>
                                                    <span style={showUsersWorkingOnJobData?.job_status === 'Open' ? openJobStatusStyle() : closeJobStatusStyle()}>
                                                        {showUsersWorkingOnJobData?.job_status}
                                                    </span>
                                                </div>
                                                <div
                                                    className="inside-card-header d-flex w-100 pt-2 pl-3"
                                                    style={{ alignItems: "center" }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#6e7491",
                                                            fontSize: "13px",
                                                            fontWeight: "500",
                                                            width: "40%",
                                                        }}
                                                    >
                                                        Currently Responsible
                                                    </span>
                                                    {showUsersWorkingOnJobData?.currently_responsible ?
                                                        <div
                                                            className="d-flex "
                                                            style={{ width: "60%", alignItems: "center" }}
                                                        >
                                                            <CircularAvatar
                                                                name={`${showUsersWorkingOnJobData?.currently_responsible} `}
                                                                image={
                                                                    showUsersWorkingOnJobData?.profile_pic &&
                                                                    showUsersWorkingOnJobData?.profile_pic?.file_url
                                                                }
                                                            />
                                                            <span
                                                                style={{
                                                                    paddingLeft: "5px",
                                                                    fontSize: "15px",
                                                                    color: "#262a44",
                                                                    fontWeight: "400",
                                                                }}
                                                            >
                                                                {showUsersWorkingOnJobData?.currently_responsible}
                                                            </span>
                                                        </div> : <span style={{
                                                            width: "60%",
                                                            fontSize: "14px",
                                                            color: "#262a44",
                                                            fontWeight: "400",
                                                        }}>--/--</span>}
                                                </div>
                                                <div
                                                    className="inside-card-header d-flex w-100 pt-2 pl-3"
                                                    style={{ alignItems: "center" }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#6e7491",
                                                            fontSize: "13px",
                                                            fontWeight: "500",
                                                            width: "40%",
                                                        }}
                                                    >
                                                        Job Manager
                                                    </span>
                                                    {showUsersWorkingOnJobData?.job_manager ?
                                                        <div
                                                            className="d-flex "
                                                            style={{ width: "60%", alignItems: "center" }}
                                                        >
                                                            <CircularAvatar
                                                                name={`${showUsersWorkingOnJobData?.job_manager} `}
                                                                image={
                                                                    showUsersWorkingOnJobData?.profile_pic &&
                                                                    showUsersWorkingOnJobData?.profile_pic?.file_url
                                                                }
                                                            />
                                                            <span
                                                                style={{
                                                                    paddingLeft: "5px",
                                                                    fontSize: "15px",
                                                                    color: "#262a44",
                                                                    fontWeight: "400",
                                                                }}
                                                            >
                                                                {showUsersWorkingOnJobData?.job_manager}
                                                            </span>
                                                        </div> : <span style={{
                                                            width: "60%",
                                                            fontSize: "14px",
                                                            color: "#262a44",
                                                            fontWeight: "400",
                                                        }}>--/--</span>}
                                                </div>



                                                <div className="inside-card-header d-flex w-100 pt-4 pl-3 pb-3">
                                                    <span
                                                        style={{
                                                            color: "#6e7491",
                                                            fontSize: "13px",
                                                            fontWeight: "500",
                                                            width: "40%",
                                                        }}
                                                    >
                                                        Job Summary
                                                    </span>
                                                    <span
                                                        style={{
                                                            width: "60%",
                                                            fontSize: "14px",
                                                            lineHeight: "23px",
                                                            color: "#262a44",
                                                            fontWeight: "400",
                                                            paddingRight: "8px",
                                                            wordWrap: "break-word"
                                                        }}
                                                    >
                                                        {showUsersWorkingOnJobData?.job_description}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </>
                            )}
                        </div>
                    </>
                </ModalBody>
            </Modal>
            <Toaster />
            {handleErrorModal()}
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.jobs.fetching,
    error: state.jobs.error,
    statusCode: state.jobs.statusCode,
    success: state.jobs.sharedJobSuccess,
    message: state.jobs.message,
    finacUser: state.auth.finacUsersList,
    loginData: state.auth.loginData
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetMessage: () => dispatch(resetMessage()),
    dispatchResetSuccess: () => dispatch(resetSharedJobSuccess()),
    dispatchResetStatusCode: () => dispatch(resetStatusCode()),
    dispatchResetError: () => dispatch(resetError()),
    dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
    dispatchShareJobsWithTeamMembersAction: (data: ShareJobsWithTeamMembersPayloadType) => dispatch(shareJobsWithTeamMembersAction(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShowShareJobModal);
